export default __webpack_public_path__ + "static/media/525.e0cca164.gif";